import React, { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { usePostDetail } from "@hooks/useFetchDetail";
import { ServicesURL } from "@utils/utilsApi";
import { openToast } from "@utils/toastStore";
import StaticGroupWizard from "../GroupWizard/StaticGroupWizard";
import {
  INITIAL_GROUP_WIZARD_DATA,
  StaticGroupWizardData,
} from "../GroupWizard/types";
import { enrollGroupToLearningObjects } from "../enrollGroupToLearningObjects";
import { updateUserStaticGroups } from "../updateUserStaticGroups";

const AddStaticGroup: React.FC = () => {
  const { id: corporateId = "" } = useParams();
  const navigate = useNavigate();
  const { t } = useTranslation("group-wizard-v2");
  const backTo = `/v2/corporate/${corporateId}/detail/users-groups?tab=static-groups`;
  const [submitting, setSubmitting] = useState(false);

  const { trigger } = usePostDetail(
    `${ServicesURL.staticGroups}/static?id_corporate=${corporateId}`,
  );

  const onComplete = async (data: StaticGroupWizardData) => {
    setSubmitting(true);
    try {
      const res = await (trigger as any)({
        name: data.name || "",
        description: data.description || "",
      });
      // TODO (BE Mancante): sostituire il ciclo di PUT per utente con
      // l'endpoint bulk (userIds sulla create del gruppo) quando disponibile.
      if (res?.id && data.userIds.length > 0) {
        const results = await Promise.allSettled(
          data.userIds.map((userId) =>
            updateUserStaticGroups(userId, {
              addGroupIds: [Number(res.id)],
              removeGroupIds: [],
            }),
          ),
        );
        const failed = results.filter((r) => r.status === "rejected").length;
        if (failed > 0) {
          openToast({
            severity: "error",
            message: String(
              t("usersAddPartial", {
                added: data.userIds.length - failed,
                total: data.userIds.length,
              }),
            ),
          });
        }
      }
      await enrollGroupToLearningObjects({
        corporateId,
        groupId: res?.id,
        groupType: "STATIC",
        loSelections: data.loSelections,
        enrollType: data.enrollConfig.enrollType || "TOP",
        config: data.enrollConfig,
      });
      navigate(backTo);
    } catch (error) {
      setSubmitting(false);
      throw error;
    }
  };

  return (
    <StaticGroupWizard
      initialData={INITIAL_GROUP_WIZARD_DATA}
      backTo={backTo}
      onComplete={onComplete}
      isCompleting={submitting}
    />
  );
};

export default AddStaticGroup;
